// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const edrpou: CountryValidator<"UA"> = createValidator(
  "ua.edrpou",
  167,
);

export default edrpou;
export const compact = edrpou.compact;
export const format = edrpou.format;
export const validate = edrpou.validate;
export const generate = (): string =>
  edrpou.generate?.() ??
  (() => {
    throw new Error(
      "Validator ua.edrpou cannot generate values",
    );
  })();
